import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface ListPlaceholderProps {
  className?: string;
}

/**
 * A single skeleton placeholder bar. Uses the shared `<Skeleton>` primitive
 * (theme-aware `bg-accent`) instead of a hardcoded gray, so it stays legible
 * in dark mode.
 */
export const ListPlaceholder = ({ className }: ListPlaceholderProps) => {
  return <Skeleton aria-hidden="true" className={cn("h-4", className)} />;
};
